<template>
  <p class="el-form-item__help" :class="typeClass">
    <i v-if="elIcon" :class="elIcon" />
    <i v-else-if="materialIcon">{{ materialIcon }}</i>
    <slot />
  </p>
</template>

<script>
export default {
  name: 'InputHelper',
  props: {
    elIcon: {
      type: String,
      default: '',
    },
    materialIcon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    typeClass() {
      if (!this.type) return '';
      return `el-form-item__help--${this.type}`;
    },
  },
};
</script>

<style></style>
